import {AppProviders} from './modules/common/providers'
import {AppRoutes} from './modules/routing'

export const App: React.FC = () => {
  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  )
}
